import { ClickEvent } from '../../types';
import { API_BASE_URL } from './types';

/**
 * Fetch click history for all buttons or a specific button
 */
export async function fetchClickHistory(counterId: string, buttonId?: string, isOwnerUrl = false): Promise<ClickEvent[]> {
  let url;
  
  if (buttonId) {
    url = `${API_BASE_URL}/api/counters/${counterId}/clicks/history/${buttonId}${isOwnerUrl ? '?isOwnerUrl=true' : ''}`;
  } else {
    url = `${API_BASE_URL}/api/counters/${counterId}/clicks/history${isOwnerUrl ? '?isOwnerUrl=true' : ''}`;
  }
  
  const response = await fetch(url);
  if (!response.ok) throw new Error('Failed to fetch history');
  return await response.json();
}

/**
 * Delete a specific click event
 */
export async function deleteClickEvent(counterId: string, eventId: string, isOwnerUrl = false): Promise<{ message: string }> {
  const url = `${API_BASE_URL}/api/counters/${counterId}/clicks/${eventId}${isOwnerUrl ? '?isOwnerUrl=true' : ''}`;

  const response = await fetch(url, {
    method: 'DELETE'
  });
  
  if (!response.ok) throw new Error('Failed to delete click event');
  return await response.json();
}

/**
 * Clear a button's click history
 */
export async function clearButtonHistory(
  counterId: string,
  buttonId: string,
  isOwnerUrl = false
): Promise<{ message: string }> {
  const url = `${API_BASE_URL}/api/counters/${counterId}/clicks/${buttonId}/clear-history${isOwnerUrl ? '?isOwnerUrl=true' : ''}`;

  const response = await fetch(url, {
    method: 'POST'
  });
  
  if (!response.ok) throw new Error('Failed to clear button history');
  return await response.json();
} 